import { getAddress } from '@ethersproject/address'

export default function useGetAddress(tokens: string[] | undefined) {
    return tokens?.map((item: string) => getAddress(item))
}